"use client";

import WebAppHeroSection from "../WebAppDevelopment/WebAppHeroSection/WebAppHeroSection";
import WebAppClientsSection from "../WebAppDevelopment/WebAppClientsSection/WebAppClientsSection";
import BusinessGrowthSection from "../WebAppDevelopment/BusinessGrowthSection/BusinessGrowthSection";
import ProblemSolveSection from "../WebAppDevelopment/ProblemSolveSection/ProblemSolveSection";
import CustomWebAppSection from "../WebAppDevelopment/CustomWebAppSection/CustomWebAppSection";
import DevelopmentPartner from "../WebAppDevelopment/DevelopmentPartner/DevelopmentPartner";
import ProcessSection from "../WebAppDevelopment/ProcessSection/ProcessSection";
import IndustriesSection from "../WebAppDevelopment/IndustriesSection/IndustriesSection";
import WebAppCtaSection from "../WebAppDevelopment/WebAppCtaSection/WebAppCtaSection";
import WebAppTestimonialSection from "../WebAppDevelopment/WebAppTestimonialSection/WebAppTestimonialSection";
import FAQSection from "@/components/FAQSection/FAQSection";

const WebAppLayout = ({ data }) => {
  return (
    <>
      <WebAppHeroSection data={data.hero} />
      <WebAppClientsSection />
      <BusinessGrowthSection data={data.businessgrowth} />
      <ProblemSolveSection data={data.problemsolve} />
      <CustomWebAppSection data={data.customwebapp} />
      <DevelopmentPartner data={data.developmentpartner} />
      <ProcessSection data={data.process} />
      <IndustriesSection data={data.industries} />
      <WebAppTestimonialSection />
      <FAQSection title={data.faq.title} faqData={data.faq.items} />
      <WebAppCtaSection data={data.cta} />
    </>
  );
};
export default WebAppLayout;
